import colors from "../../base/colors";

const { transparent, secondary, primary } = colors;

export default {
  styleOverrides: {
    root: {
      backgroundColor: transparent.main,
      "& .MuiOutlinedInput-notchedOutline, &:hover": {
        borderColor: primary.main,
      },
      "& .MuiOutlinedInput-notchedOutline, &:hover": {
        borderColor: secondary.main,
      },
      
      
    },
  },
};
